import { render, staticRenderFns } from "./NSRComponent.vue?vue&type=template&id=0fa6380e&scoped=true"
import script from "./NSRComponent.js?vue&type=script&lang=js&external"
export * from "./NSRComponent.js?vue&type=script&lang=js&external"
import style0 from "./NSRComponent.scss?vue&type=style&index=0&id=0fa6380e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa6380e",
  null
  
)

export default component.exports